import { Link } from "react-router-dom";
import { ArrowRight, Umbrella, Wallet, HeartHandshake } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Motion";
import PageSeo from "@/components/PageSeo";

const COVERS = [
  {
    icon: Umbrella,
    title: "Incapacité de travail",
    text: "En cas d'arrêt de travail lié à une maladie ou un accident, percevez des indemnités journalières qui compensent la perte de revenus — essentiel pour un TNS sans couverture collective.",
  },
  {
    icon: Wallet,
    title: "Invalidité",
    text: "Si une invalidité partielle ou totale vous empêche durablement d'exercer, une rente vient maintenir votre niveau de vie et celui de votre foyer.",
  },
  {
    icon: HeartHandshake,
    title: "Décès",
    text: "Un capital versé à vos proches pour faire face aux conséquences financières d'un décès : droits de succession, remboursement des emprunts, protection de la famille.",
  },
];

export default function Prevoyance() {
  return (
    <div data-testid="prevoyance-page">
      <PageSeo path="/prevoyance" />
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 py-16 lg:py-24">
        <Reveal y={12}>
          <SectionTag className="mb-4">Prévoyance dirigeants TNS</SectionTag>
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-extrabold uppercase tracking-tighter leading-[0.9] mb-6">
            Si tout s'arrête,<br />tout <span className="text-accent">continue.</span>
          </h1>
          <p className="max-w-2xl text-base sm:text-lg leading-relaxed text-ink/75 mb-8">
            Artisan et travailleur non salarié, votre revenu dépend entièrement de votre
            capacité à travailler. La prévoyance TNS sécurise vos revenus et votre famille en
            cas de coup dur — avec des cotisations déductibles grâce à la loi Madelin.
          </p>
          <p className="max-w-2xl text-base leading-relaxed text-ink/75 mb-20">
            Contrairement aux salariés, le dirigeant TNS ne bénéficie d'aucune prévoyance
            collective : sans contrat dédié, un arrêt de travail prolongé peut mettre en péril
            l'entreprise et le foyer.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-3 border-t border-l border-ink/15 mb-20">
          {COVERS.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.06} y={16}>
              <div className="flex h-full flex-col gap-4 border-b border-r border-ink/15 p-8 min-h-[260px] transition-colors hover:bg-ink hover:text-paper group">
                <c.icon className="h-7 w-7 text-accent" />
                <h2 className="mt-auto font-display text-xl font-bold uppercase tracking-tight">{c.title}</h2>
                <p className="text-sm leading-relaxed text-ink/70 group-hover:text-paper/75">{c.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="flex flex-wrap items-center justify-between gap-6 border-2 border-ink bg-night text-paper p-8 sm:p-12 shadow-brutal-accent">
          <div>
            <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tighter">
              Protégez ce que vous avez construit.
            </h2>
            <p className="mt-2 text-sm text-paper/70 max-w-xl">
              Demandez votre devis prévoyance : un spécialiste vous rappelle et construit avec
              vous les garanties adaptées à votre situation de TNS.
            </p>
          </div>
          <Link
            to="/devis"
            data-testid="prevoyance-cta-devis"
            className="inline-flex items-center gap-2 border-2 border-accent bg-accent px-8 py-4 font-mono text-xs uppercase tracking-[0.2em] text-paper transition-colors hover:bg-transparent"
          >
            Demander un devis
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </div>
  );
}
